import style from './GenericPageLayout.module.scss';
import { BlockType } from 'components/general/switchBlock/SwitchBlock';
import { useThemeContext } from 'context/ThemeContext';
import React, { useEffect } from 'react';
import { StandardIntro } from 'components/standardIntro/StandardIntro';
import { StandardBlocksLayout } from 'components/general/standardBlocksLayout/StandardBlocksLayout';
import { ContentPageTitle } from 'components/contentPageTitle/ContentPageTitle';
import { GlobalDataType } from 'utils/parsers';
import { widont } from 'utils/typography';

export type GenericPageLayoutProps = {
  blockStyles?: string | undefined | null; //// we can overwrite content blocks from the CMS here
  blocks: BlockType[];
  meta_title: string;
  meta_description: string;
  meta_image: string;
  title: string;
  heading: string;
  intro?: string;
  originalResponse: any;
  globalData: GlobalDataType
} & { children: React.ReactNode };

const GenericPageLayout = (props: GenericPageLayoutProps) => {
  const {
    intro,
    blocks,
    heading,
    blockStyles,
    children,
  } = props;

  const { setTheme } = useThemeContext();

  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <div className={`${style.container}`}>
      <div className={`${style.pageIntroContainer}`}>
        <StandardIntro intro={{ html: widont(intro) }} />
      </div>
      <div className={`${style.pageTitleContainer}`}>
        <ContentPageTitle title={heading} />
      </div>

      <div className={style.contentContainer}>
        <div className={style.content}>
          <StandardBlocksLayout blocks={blocks} blockStyles={blockStyles || undefined} />
        </div>
        {/* we can add children outside of the Blocks here */}
        <div className={style.customChildren}>{children}</div>
      </div>
    </div>
  );
};

export default GenericPageLayout;
